import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { Alert, Input, Button } from '../../../UI/Common';
import { validationSchema } from './validation';
import { Form, Row, Col, FormFeedback } from 'reactstrap';
import { useHistory } from 'react-router-dom';

const AddNotePage = (props) => {
  const history = useHistory();
  const { t, isSubmitting, sensorIds, sensorName } = props;
  function getTitle() {
    if (sensorIds.split(',').length > 1) {
      return `Add Note: <${t('Multiple alarms')}>`;
    }
    return `Add Note: ${sensorName}`;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <Row>
          <Col>
            <Button classes="mb-10" onClick={() => history.goBack()}>
              Back
            </Button>
            <Formik
              initialValues={{ note: '' }}
              validationSchema={validationSchema}
              onSubmit={(values) => props.onAddNote(values)}
            >
              {({ values, handleChange, errors, touched, handleSubmit }) => {
                return (
                  <Form>
                    <Input
                      required
                      type="textarea"
                      inputClass="custom-text-area"
                      label="Note"
                      id="note"
                      onChange={handleChange('note')}
                      value={values.note}
                      invalid={errors.note && touched.note}
                      error={errors.note}
                      accessory={
                        <FormFeedback
                          className="d-flex justify-content-end"
                          style={{
                            color: values.note.length > 250 ? 'red' : 'black',
                          }}
                        >
                          {values.note.length}/250 characters
                        </FormFeedback>
                      }
                    />

                    <Alert.Error text={props.errors} />
                    <Button
                      id="add-note"
                      loading={isSubmitting}
                      onClick={handleSubmit}
                    >
                      <i className="md-icon">done</i>
                      {t('Add')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col />
        </Row>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(AddNotePage);
